import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { encrypt, decrypt } from '../functions/mobile';
import LoadingScreen from '../components/Complements/LoadingScreen';
import Dashboard from '../components/Menu/Dashboard';
import DialogOTP from '../components/Complements/DialogOTP';
import ChangeQuotasForm from '../components/ChangeQuotas/ChangeQuotasForm';
import { makeStyles } from '@material-ui/core';
//import { osName, osVersion } from "react-device-detect";
import { filterArrayEqual } from '../functions/arrays';
import { createCode } from './../actions/codes'
import { updateQuotas } from './../actions/quotas';
import { feathersCreateData } from '../services';

class ChangeQuotasContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            datauserquotas: {},
            amountdaily: 0,
            amountmonthly: 0,
            newamountdaily: 0,
            newamountmonthly: 0,
            openDialogOTP: false,
            otp: '',
            initialTime: Date.now(),
            seq: '',
            contAttempts : 0,
            loading: false
        }
    }

    handleChangeInputOtp = (valueinput) => {
        if(valueinput.target.value.toString().length === 4){
            // console.log("VALUE OTP: ", valueinput)
            this.receiveOTP({data : valueinput.target.value.toString()});
        }

    }

    receiveOTP = async(otp) => {
        //this.setState({ otp: otp.data})
        // console.log('el codigo otp ', otp.data)
        try {

            this.setState({
                loading : true
            })

            const {ip, device, mac} = this.props.devices

            const sendData = encrypt(JSON.stringify({
                ip,
                mac,
                device,
                type : 21,
                inputOtp : otp.data
            }))
            
            const responseValidateCode = await feathersCreateData("code-validation", { sendData })()

            //console.log("Respuesta: ", responseValidateCode)

            //const responseValidateCodeDecrypt = JSON.parse(decrypt(responseValidateCode.responseData))

            //console.log(responseValidateCodeDecrypt)

            const { error, message, type, viewDialogOtp } = responseValidateCode;
            
            if (error === false) {
        
                const { newamountdaily, newamountmonthly} = this.state;
                this.handleCloseDialogOTP()
    
                const sendDataUpdateQuotas = {
                    dataQuotas : encrypt(JSON.stringify({
                        daily : newamountdaily,
                        monthly : newamountmonthly,
                        idQuotas : this.props.quotas[0].id 
                    })),
                    device : encrypt(JSON.stringify({
                        ip,
                        mac,
                        device
                    })),
                    otp : encrypt(otp.data)
                }

                const responseUpdateQuotas = await feathersCreateData("quota-validation", sendDataUpdateQuotas)()

                const { message : messageUpdateQuotas, type : typeUpdateQuotas } = responseUpdateQuotas

                this.setState({
                    loading : false
                })

                this.props.handleOpenSnack(messageUpdateQuotas, typeUpdateQuotas)
                // console.log(id)
                
            } else {
                this.props.handleOpenSnack(message, type)
                if(viewDialogOtp === false){
                    this.handleCloseDialogOTP()
                }
                this.setState({
                    loading : false
                })
                this.props.handleOpenSnack(message, type);
            } 

        } catch (error) {
            this.setState({
                loading : false
            })
            this.props.handleOpenSnack('Ha ocurrido un error al validar el código. Por favor intente nuevamente.', 'error')
        }

    }
    // handle kyuin123
    handleSubmit = async(values) => {
        //console.log(values)
        try {
            const { parameters, devices } = this.props
            let amountdailymax = (parameters.length > 0) ? filterArrayEqual(parameters, 'name', 'MontoDiario')[0].value : 10000;
            let amountmonthlymax = (parameters.length > 0) ? filterArrayEqual(parameters, 'name', 'montoMensual')[0].value : 40000;
            this.setState({loading: true, amountdaily: values.amountdaily, amountmonthly: values.amountmonthly})
            
            if((parseInt(values.amountdaily) <= amountdailymax) && (parseInt(values.amountmonthly) <= amountmonthlymax)){
                if (parseInt(values.amountdaily) > parseInt(values.amountmonthly) ) {
                    this.setState({loading: false})
                    this.props.handleOpenSnack('El monto diario no puede ser mayor que el monto mensual.', 'error')
                } else {
                    const { ip, mac, device } = devices
                    const sendData = encrypt(JSON.stringify({emited: 'NAVCREATECODE', type : 21, deviceData: device, ip, mac }))
                    const responseGenerateCode = await feathersCreateData("codes-recovery", { sendData })()
                    const { responseData } = responseGenerateCode
                    const jsonDecrypt = JSON.parse(decrypt(responseData))

                    const { type, alert } = jsonDecrypt;

                    if(type === 'success'){
                        this.setState(
                            {   openDialogOTP: true, 
                                newamountdaily: values.amountdaily,
                                newamountmonthly: values.amountmonthly, 
                                loading: false 
                            })
                    }else{
                        this.props.handleOpenSnack(alert, type)
                    }
                    
                }
            }else{
                this.setState({loading: false})
                this.props.handleOpenSnack('Se ha excedido el limite de las cuotas. El limite permitido diario es $ '+amountdailymax+' y mensual $ '+amountmonthlymax+'.', 'info');
            }
        } catch (error) {
            this.setState({loading: false})
            //console.log('error submit', error)
            this.props.handleOpenSnack('No se ha podido realizar la acción. Por favor intente nuevamente.', 'error')
        }
        
    }
        
    handleCloseDialogOTP = () => {
        this.setState({ openDialogOTP: false })
    };

    componentDidMount = () => {
        this.setState({
            amountdaily : (this.props.quotas.length > 0) ? this.props.quotas[0].daily : 0,
            amountmonthly : (this.props.quotas.length > 0) ? this.props.quotas[0].monthly : 0
        })
        //console.log(this.props.quotas[0].daily);
    }

    renderBody = () => {

        const useStyles = makeStyles(theme => ({
            textField: {
                width: 200,
            },
            margin: {
                margin: theme.spacing(1),
            },
        }));

        return  <div>
                    <ChangeQuotasForm 
                        {...this.state}
                        classes = { useStyles }
                        onSubmit = { this.handleSubmit }
                    />
                    <DialogOTP
                        {...this.state} 
                        showQR = {false}
                        onCloseDialogOTP = { this.handleCloseDialogOTP }
                        onKeyPress = { this.handleChangeInputOtp }
                        OTPSubmit = { this.receiveOTP }
                        initialTime = { Date.now()}
                    />
                </div>
    }

    render() {
        const {loading} = this.state
        
        return (
            <div>
                <LoadingScreen open={loading} />
                <Dashboard
                    title= ""
                    body = { this.renderBody() }
                    multiple = { false }
                />
            </div>
        );
    }
}

export default withRouter(connect(null, { createCode, updateQuotas } )(ChangeQuotasContainer))
